import { IPbrInputProps } from "../PbrInput/PbrInput";
import * as React from "react";
import { WrappedFormUtils } from "antd/lib/form/Form";
import { PbrFormItem } from "../PbrFormItem/PbrFormItem";
import { FormItemProps } from "antd/lib/form";
import { InputNumber } from "antd";
import "./input-money.scss";

export function PbrInputMoney(
  props: {
    onChange?: (floatvalue: number) => void;
    name: string;
    rules?: any[];
    value: number;
    formWrapper?: WrappedFormUtils;
    formItemProps?: FormItemProps;
  } & IPbrInputProps
) {
  const getFieldDecorator = props.formWrapper ? props.formWrapper.getFieldDecorator : null;
  const formItemProsp = props.formItemProps;
  const onChange = props.onChange;
  const state = { ...props };
  const value = props.value;

  function numberToReal(numero) {
    if (numero) {
      numero = parseFloat(numero)
        .toFixed(2)
        .split(".");
      numero[0] = "R$ " + numero[0].split(/(?=(?:...)*$)/).join(".");
      return numero.join(",");
    } else {
      return "R$ 0,00";
    }
  }

  function parser(v: string) {
    if (v) {
      const aux = v.replace(/[^0-9]/g, "");
      let floatNumber;
      if (aux.length > 1) {
        floatNumber = parseFloat([aux.substr(0, aux.length - 2), aux.slice(-2)].join("."));
      } else {
        floatNumber = parseFloat(["0", "0" + aux].join("."));
      }
      return floatNumber;
    } else {
      return NaN;
    }
  }

  function handleChange(v) {
    onChange(v ? v : 0);
  }

  delete state.value;
  delete state.onChange;
  delete state.formWrapper;
  delete state.formItemProps;

  return (
    <PbrFormItem {...formItemProsp} className="pbr-standard-input monetary-input">
      {(getFieldDecorator &&
        getFieldDecorator(props.name, { rules: props.rules, initialValue: value === 0 ? "" : value })(
          <InputNumber name={props.name} className="ant-input" formatter={v => numberToReal(v)} parser={v => parser(v)} onChange={handleChange} disabled={props.disabled} />
        )) || (
          <InputNumber
            name={props.name}
            className="ant-input"
            defaultValue={value}
            formatter={v => numberToReal(v)}
            parser={v => parser(v)}
            onChange={handleChange}
            disabled={props.disabled}
          />
        )}
    </PbrFormItem>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/PbrInputMoney/PbrInputMoney.tsx